package dev.inmo.wishlist.features.auth.client

import dev.inmo.wishlist.features.auth.common.models.AuthCredentials
import dev.inmo.wishlist.features.auth.common.models.AuthConfig
import dev.inmo.wishlist.features.auth.common.models.AuthFeatureUser
import dev.inmo.wishlist.features.auth.common.models.Password
import dev.inmo.wishlist.features.auth.common.models.RefreshToken
import dev.inmo.wishlist.features.auth.common.models.RegistrationResult
import dev.inmo.wishlist.features.email.common.models.Email
import dev.inmo.wishlist.features.users.common.models.Username

class AuthFeatureService(
    private val storage: AuthCredentialsStorage,
    private val feature: ClientAuthFeature
) : ClientAuthFeature {
    override suspend fun login(username: Username, password: Password): AuthCredentials? {
        val credentials = feature.login(username, password) ?: return null
        storage.save(credentials)
        return credentials
    }

    override suspend fun refresh(refreshToken: RefreshToken): AuthCredentials? {
        val credentials = feature.refresh(refreshToken) ?: return null
        storage.save(credentials)
        return credentials
    }

    override suspend fun logout() {
        feature.logout()
        storage.save(null)
    }

    /** Delegates the legacy registration surface to the email-aware service flow. */
    override suspend fun register(username: Username, password: Password): RegistrationResult? =
        register(username, password, null)

    override suspend fun register(username: Username, password: Password, email: Email?): RegistrationResult? {
        val result = feature.register(username, password, email) ?: return null
        if (result is RegistrationResult.Authorized) {
            storage.save(result.credentials)
        }
        return result
    }

    override suspend fun getConfig(): AuthConfig = feature.getConfig()

    override suspend fun isRegistrationAvailable(): Boolean = feature.isRegistrationAvailable()

    override suspend fun getMe(): AuthFeatureUser? {
        if (storage.userAuthorised.value == false) {
            return null
        }
        return feature.getMe()
    }
}
